exports = module.exports = require("../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".top[data-v-fd5e6090]{width:980px;margin:auto;padding:20px 10px 0;color:#fff;font-size:1.2em}.top [data-v-fd5e6090]{vertical-align:middle}.book[data-v-fd5e6090]{display:flex;justify-content:space-around;flex-wrap:wrap;width:980px;margin:auto;padding:5px;background-color:#3b88c8}.page[data-v-fd5e6090]{width:980px;margin:auto;color:#fff;text-align:center;padding:20px 0}.page a[data-v-fd5e6090]{text-decoration:none}.page a[data-v-fd5e6090]:link,.page a[data-v-fd5e6090]:visited{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?minimize!./~/.11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-fd5e6090","scoped":true,"hasInlineConfig":false}!./~/.11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/Books.vue
// module id = 200
// module chunks = 2